import { useOverflow } from "../../../../shared";
import {
    TOOLTIP_PLACEMENT,
    TooltipGeneral
} from "../../../DesignComponents/Tooltips";
import { FoundResourceCompanyRowProps } from "../types";

const FoundResourceCompanyRow = ({
    companyType,
    companyName
}: FoundResourceCompanyRowProps) => {
    const { ref, isOverflowing } = useOverflow([]);

    return (
        <div>
            <span>{companyType}:</span>

            <TooltipGeneral
                title={companyName}
                disableHoverListener={!isOverflowing}
                placement={TOOLTIP_PLACEMENT.Top}
            >
                <span ref={ref}>{companyName}</span>
            </TooltipGeneral>
        </div>
    );
};

export default FoundResourceCompanyRow;
